import { Modal, ModalSize, useMedia } from "@next-platform/client-common-spicy-ui";
import React, { useEffect } from "react";

interface Sticky3dsSuccessData {
  status: "success";
  [key: string]: unknown;
}

interface Sticky3dsModalProps {
  isOpen: boolean;
  iframeUrl: string;
  onSuccess: (data: Sticky3dsSuccessData) => void;
  onFailure: (message: string) => void;
  onClose: () => void;
}

const Sticky3dsModal = ({ isOpen, iframeUrl, onClose, onSuccess, onFailure }: Sticky3dsModalProps) => {
  const { isMobile } = useMedia();

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.status === "success") {
        //console.info("3DS success", event.data);
        onSuccess(event.data);
      } else if (event.data?.status === "failure") {
        //console.warn("3DS failed", event.data);
        onFailure(event.data?.error_message);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [onClose, onSuccess, onFailure]);

  return (
    <Modal
      open={isOpen}
      onOpenChange={onClose}
      backdrop="blur"
      size={ModalSize.Free}
      className={`!w-[672px] ${isMobile ? "!size-full max-h-full max-w-full" : ""}`}
      classNames={{
        close: "!bg-gray-10 text-white mt-md mr-md",
      }}
    >
      <iframe src={iframeUrl} title="3DS Verification" width="100%" height="400px" frameBorder="0"></iframe>
    </Modal>
  );
};

export default Sticky3dsModal;
